// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import { BookitupNotification } from '../../../../Types/LogT';

const MailSent: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { value } = notification;
  const translation = i18n._(`message.type.${value?.toLowerCase()}`);
  const subject = translation.includes('message.type') ? value : translation;

  return (
    <Text>
      Mail{'  '}
      <Text span weight="bolder">
        {subject}
      </Text>
      {'  '}
      wurde gesendet.
    </Text>
  );
};

export default MailSent;
